import { Box, Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';

import {
  OfferTypes,
  cancelFlow_cancelOfferClick,
  cancelFlow_cancelOfferScreenLoad,
} from 'services/analytics/trackers/cancelFlow';

import useReturnOffer from 'hooks/subscriptions/useReturnOffer';
import { useModals } from 'hooks';

import ModalHeader from 'components/ModalHeader/ModalHeader';
import Modal from 'components/Modal';
import DiscountOffer from 'components/DiscountOffer';

import * as S from './styled';
import { getDiscount } from 'helpers/prices';

const defaultDiscount = 80;

const ReturnOfferContainer = () => {
  const { t } = useTranslation();
  const { closeModal } = useModals();

  const { resetCandidate, resetCandidatePriceData, discountPriceData, onResetSubscription } = useReturnOffer();

  const handleReset = () => {
    onResetSubscription();

    if (resetCandidate) {
      cancelFlow_cancelOfferClick({
        action: 'claim_offer',
        subscription_id: resetCandidate.external_id,
        offer_type: OfferTypes.Return_offer,
      });
    }
  };

  const handleClose = () => {
    closeModal();

    if (resetCandidate) {
      cancelFlow_cancelOfferClick({
        action: 'close',
        subscription_id: resetCandidate.external_id,
        offer_type: OfferTypes.Return_offer,
      });
    }
  };

  useEffect(() => {
    if (resetCandidate) {
      cancelFlow_cancelOfferScreenLoad({
        offer_type: OfferTypes.Return_offer,
        subscription_id: resetCandidate.external_id,
      });
    }
  }, [resetCandidate]);

  const discountPercentage = React.useMemo(() => {
    if (!resetCandidate || !discountPriceData) {
      return defaultDiscount;
    }

    return getDiscount(parseInt(resetCandidate.price), parseInt(discountPriceData.price));
  }, [resetCandidatePriceData, discountPriceData]);

  return (
    <Modal isOpen fullscreen>
      <>
        <ModalHeader title={t('subscription.text.cancel')} onClose={handleClose} />
        <S.ModalContainer data-locator="discountOfferContainer">
          <S.SubscriptionAdditionalInfo>
            <Text mb={8}>{t('basics.subscription.cancelledTitle')}</Text>
            <Text>{t('subscription.cancellation.returnOffer.statusAdditionalInfo', { minutesAmount: 15 })}</Text>
          </S.SubscriptionAdditionalInfo>
          <Box $paddingX={25}>
            <Text type="h4" medium center mb={12}>
              {t('subscription.cancellation.specialOffer.withDynamicPercent.title', { percent: discountPercentage })}
            </Text>
            <Text type="large-text" center mb={24}>
              {t('subscription.cancellation.specialOffer.withDynamicPercent.subtitle')}
            </Text>
          </Box>
          <DiscountOffer
            mb={24}
            badgeBackgroundColor="text-secondary"
            badgeText="subscription.cancellation.specialOffer.firstBadge"
            price={resetCandidatePriceData.price}
            period={resetCandidatePriceData.period}
            currencySign={resetCandidatePriceData.currency}
          />
          <DiscountOffer
            mb={24}
            badgeBackgroundColor="critical-default"
            badgeText="subscription.cancellation.specialOffer.withDynamicPercent.secondBadge"
            badgePercent={discountPercentage}
            isNewOffer
            oldPrice={resetCandidatePriceData!.price}
            price={discountPriceData!.price}
            period={discountPriceData!.period}
            currencySign={discountPriceData!.currency}
            onSubmitDiscount={handleReset}
          />
        </S.ModalContainer>
      </>
    </Modal>
  );
};

export default ReturnOfferContainer;
